<template>
    <div class="box-shadow rounded-lg overflow-hidden mb-4 h-24 bg-white">
        <div class="grid grid-cols-3">
            <div>
                <img class="p-4 h-24 w-full" :src="purchase.fullImageUrl" alt=""/>
            </div>
            <div class="col-span-2">
                <div class="p-4 pl-0 h-full">
                    <div class="text-12 font-normal text-a-black-484848">{{cutStringName}}</div>
                    <div class="flex justify-between items-end h-12">
                        <div class="text-10 font-light text-a-gray-afafaf">{{FilterDateTimeFormat(purchase.redeemDate)}}</div>
                        <OrangeButton
                            v-if="isShowPurchaseMsg"
                            :customClass="`w-18 py-3 rounded-full
                                ${isExpireDate ? `bg-a-gray-d0d0ce` : `bg-a-orange-fe5000` }`"
                            :disabled="isExpireDate"
                            @click="clickPurchase()"
                        >
                            <div class="text-10 font-light">
                                {{isExpireDate ? `หมดอายุ` : `ดูรหัส`}}
                            </div>
                        </OrangeButton>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import OrangeButton from '@/components/Button/OrangeButton.vue';

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin],
    props: {
        purchase: { type: Object, required: true },
    },
    components: {
        OrangeButton,
    },
    data: function() {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
        };
    },
    created: function() {
        this.initialPurchase();
    },
    computed: {
        isShowPurchaseMsg: function() {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface';
        },
        isExpireDate: function(){
            return this.purchase.serial === 'XXXXXXX'
        },
        cutStringName: function(){
            let str = this.purchase.name
            if(str.length > 36){
                str = str.slice(0, 36) + '...'
            }
            return str
        },
    },
    methods: {
        getPointMessage: function () {
            let pointType = this.purchase.pointType == 'get' ? this.lbl.history.get_point : this.lbl.history.use_point;
            let pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            //purchase message.
            switch(this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                    } else {
                        this.isActive = true;
                        this.purchaseMessage = this.lbl.purchase.show_code;
                    }
                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            this.purchaseMessage = this.lbl.purchase.interface_use;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },

        clickPurchase: function() {
            this.$emit('onClickPurchase', this.purchase);
        },
    }
}
</script>
<style lang="scss" scoped>
    .box-shadow {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }
</style>
